// ===== 完成サイズ計算 =====
let calcW = 0, calcH = 0;

document.getElementById('btn-size').addEventListener('click', function () {
  const w = parseFloat(document.getElementById('stitch-w').value);
  const h = parseFloat(document.getElementById('stitch-h').value);
  const ct = parseFloat(document.getElementById('count-select').value);
  if (!w || !h || !ct) {
    document.getElementById('result-size').textContent = '横・縦のステッチ数を入力してください。';
    return;
  }
  calcW = (w / ct) * 2.54;
  calcH = (h / ct) * 2.54;
  document.getElementById('result-size').innerHTML =
    `完成サイズ：<strong>${calcW.toFixed(1)} cm × ${calcH.toFixed(1)} cm</strong>`;
});

document.getElementById('btn-fabric').addEventListener('click', function () {
  if (!calcW || !calcH) {
    document.getElementById('result-fabric').textContent = '先に「計算する」で完成サイズを計算してください。';
    return;
  }
  const m = parseFloat(document.getElementById('margin').value) || 0;
  const fw = calcW + m * 2;
  const fh = calcH + m * 2;
  document.getElementById('result-fabric').innerHTML =
    `必要な布サイズ：<strong>${fw.toFixed(1)} cm × ${fh.toFixed(1)} cm</strong>（余白 ${m}cm 含む）`;
});

// ===== カウント変換 =====
let convW = 0, convH = 0;

document.getElementById('btn-conv').addEventListener('click', function () {
  const sw = parseFloat(document.getElementById('conv-stitch-w').value);
  const sh = parseFloat(document.getElementById('conv-stitch-h').value);
  const from = parseFloat(document.getElementById('conv-from').value);
  const to = parseFloat(document.getElementById('conv-to').value);
  if (!sw || !sh) {
    document.getElementById('result-conv').textContent = 'ステッチ数を入力してください。';
    return;
  }
  convW = Math.round(sw * to / from);
  convH = Math.round(sh * to / from);
  const sizeW = ((convW / to) * 2.54).toFixed(1);
  const sizeH = ((convH / to) * 2.54).toFixed(1);
  document.getElementById('result-conv').innerHTML =
    `変換後：<strong>${convW} st × ${convH} st</strong>（完成サイズ目安：${sizeW} cm × ${sizeH} cm）`;
});

document.getElementById('btn-conv-fabric').addEventListener('click', function () {
  if (!convW || !convH) {
    document.getElementById('result-conv-fabric').textContent = '先に「変換する」でカウント変換をしてください。';
    return;
  }
  const ct = parseFloat(document.getElementById('conv-to').value);
  const m = parseFloat(document.getElementById('conv-margin').value) || 0;
  const fw = ((convW / ct) * 2.54 + m * 2).toFixed(1);
  const fh = ((convH / ct) * 2.54 + m * 2).toFixed(1);
  document.getElementById('result-conv-fabric').innerHTML =
    `必要な布サイズ：<strong>${fw} cm × ${fh} cm</strong>（余白 ${m}cm 含む）`;
});

// ===== 早見表生成 =====
(function () {
  const counts = [11, 14, 16, 18, 24, 25, 28, 30, 32, 46];
  const stitches = [30, 50, 100, 150, 200];
  const tbody = document.getElementById('quick-table');
  if (!tbody) return;
  counts.forEach(function (ct) {
    const tr = document.createElement('tr');
    tr.innerHTML = '<td><strong>' + ct + 'ct</strong></td>' +
      stitches.map(function (st) {
        return '<td>' + ((st / ct) * 2.54).toFixed(1) + '</td>';
      }).join('');
    tbody.appendChild(tr);
  });
})();
